// import PrivateLayout from 'components/PrivateLayout';
import RecruiterAndMarketerLayout from 'components/RecruiterAndMarketerLayout';
import { IPriseJobsPreview } from 'pages/common/IPriseJobs';
import JobQueuePage from 'pages/common/IPriseJobs/JobQueuePage';
import { ResumeValidationTable } from 'pages/common/ResumeValidation/ResumeValidation';
import VersionHistory from 'pages/public/VersionHistory';
import { Candidates } from 'pages/sales/Candidates';
import { JobPosting } from 'pages/sales/JobPosting';
import { ViewJob } from 'pages/sales/JobPosting/ViewJob';
import Myprofile from 'pages/sales/Myprofile';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { SalesRoute } from '../index';

const SalesRoutes = () => {
  const {
    CANDIDATES,
    JOBPOST,
    VIEWJOB,
    MYPROFILE,
    RESUMEVALIDATION,
    VERSIONHISTORY,
    VIEWipriseJOB,
    JOBiprisePOST,
    VIEWipriseCANDIDATE,
  } = SalesRoute;
  return (
    <Routes>
      <Route path="/" element={<Navigate to={JOBPOST} />} />
      <Route
        path={JOBPOST}
        element={
          <RecruiterAndMarketerLayout
            routes={{
              path: JOBPOST,
              show: false,
              title: 'Job Posting',
            }}
            from={'jobpost'}
            showHeader={true}>
            <JobPosting />
          </RecruiterAndMarketerLayout>
        }
      />
      <Route
        path={JOBiprisePOST}
        element={
          <RecruiterAndMarketerLayout
            routes={{
              path: JOBiprisePOST,
              show: false,
              title: 'Job Posting',
            }}
            from={'viewipriseJob'}
            showHeader={true}>
            <JobQueuePage />
          </RecruiterAndMarketerLayout>
        }
      />
      <Route
        path={VIEWJOB}
        element={
          <RecruiterAndMarketerLayout
            routes={{
              path: VIEWJOB,
              show: false,
              title: 'View Job',
            }}
            from={'viewjob'}
            showHeader={true}>
            <ViewJob />
          </RecruiterAndMarketerLayout>
        }
      />
      <Route
        path={VIEWipriseJOB.concat('/:jobId')}
        element={
          <RecruiterAndMarketerLayout
            routes={{
              path: VIEWipriseJOB.concat('/:jobId'),
              show: false,
              title: 'View Job',
            }}
            from={'viewipriseJob'}
            showHeader={true}>
            <ViewJob />
          </RecruiterAndMarketerLayout>
        }
      />
      <Route
        path={VIEWipriseCANDIDATE.concat('/:jobId/:candidateId')}
        element={
          <RecruiterAndMarketerLayout
            routes={{
              path: VIEWipriseCANDIDATE.concat('/:jobId/:candidateId'),
              show: false,
              title: 'Candidate Info',
            }}
            from={'viewipriseCandidate'}
            showHeader={true}>
            <IPriseJobsPreview visible={true} />
          </RecruiterAndMarketerLayout>
        }
      />
      <Route
        path={CANDIDATES}
        element={
          <RecruiterAndMarketerLayout
            routes={{
              path: CANDIDATES,
              show: false,
              title: 'Candidates',
            }}
            from={'candidates'}
            showHeader={true}>
            <Candidates />
          </RecruiterAndMarketerLayout>
        }
      />
      <Route
        path={RESUMEVALIDATION}
        element={
          <RecruiterAndMarketerLayout
            routes={{
              path: RESUMEVALIDATION,
              show: false,
              title: 'Resume Validation',
            }}
            from={'resumevalidation'}
            showHeader={true}>
            <ResumeValidationTable />
          </RecruiterAndMarketerLayout>
        }
      />

      <Route
        path={MYPROFILE}
        element={
          <RecruiterAndMarketerLayout
            routes={{
              path: MYPROFILE,
              show: false,
              title: 'Job Posting',
            }}
            from={'profile'}
            showHeader={true}>
            <Myprofile />
          </RecruiterAndMarketerLayout>
        }
      />

      <Route path={VERSIONHISTORY} element={<VersionHistory />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default SalesRoutes;
